import type { Coordinate } from '@/types/properties';
import type { MoreProps, RenderNodesMap } from '@/types/commontypes';
import { isDefined } from 'react-financial-charts';
import { findMatchingShape } from './findMatchingShape';
import { getXValue } from '@react-financial-charts/core/lib/utils/ChartDataUtil';

/**
 * Checks whether a mouse click landed on an existing shape.
 * No longer mutates renderNodes — deselection is handled by setting selectedShape to null.
 */
export function isClickOnShape(e: React.MouseEvent, moreProps: MoreProps, renderNodes: RenderNodesMap): boolean {
  const { xAccessor, plotData } = moreProps;
  const {
    mouseXY,
    currentItem,
    xScale,
    chartConfig: { yScale },
  } = moreProps;

  if (isDefined(currentItem) && isDefined(e)) {
    const xValue = getXValue(xScale, xAccessor, mouseXY, plotData ?? []);
    const yValue = yScale.invert(mouseXY[1]);
    const clickedPosition: Coordinate = [xValue, yValue];

    const matches = findMatchingShape(clickedPosition, renderNodes, 1);
    return matches.length > 0;
  }
  return false;
}
